import { defineComponent as _defineComponent } from 'vue';
import { ComboboxEmpty } from 'reka-ui';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ComboboxEmpty',
    setup(__props, { expose: __expose }) {
        __expose();
        const __returned__ = { get ComboboxEmpty() { return ComboboxEmpty; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
